import { IoSunny } from "react-icons/io5";
import { MdModeNight } from "react-icons/md";
import styled from "styled-components";
import { useStyledTheme } from "../../theme";
import React from "react";

const Wrapper = styled.div`
  display: none;
  position: absolute;
  top: 20px;
  right: 20px;
  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Mode = () => {
  const { themeToggle, mode } = useStyledTheme();
  return (
    <Wrapper onClick={themeToggle}>
      {mode === "light" ? (
        <IoSunny color="orange" />
      ) : (
        <MdModeNight color="#fff" />
      )}
    </Wrapper>
  );
};
